import React from 'react'
import request from 'superagent';
import {getColorStyle, timeoutRedirect} from './Util';
import {URL_SEVENS} from "../constants/Url";
import {Link} from "react-router-dom";
// import TagManager from 'react-gtm-module'
// import {getTagManagerArgs} from './Util';

export default class Sevens extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      results: []
    }
  }

  handleClickOpen(unit_id) {
    const {handleModalOpen} = this.props
    handleModalOpen(unit_id)
  }

  handleClickClose() {
    const {handleModalClose} = this.props
    handleModalClose()
  }

  handleClickSwitchPage(page) {
    this.props.switchPageMethod(page)
  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    request
      .get(URL_SEVENS(this.props.access_token, this.props.gender, this.props.kit))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
        }

        if (!res || !res.body.result) {
          timeoutRedirect()
        }

        this.setState({
          results: res.body.result
        })
      })
  }

  render() {
    // TagManager.initialize(getTagManagerArgs('/sevens'));

    return (
      <div className="wrap">

        <div className="titlearea">
          <h2>七大疾病（七大生活習慣病）のリスク評価</h2>
        </div>
        <p className="text_description">日本人の罹患率の高い七大疾病に関するリスク評価を一覧でご確認いただけます。
          「がん」「心疾患」「脳卒中」の三大疾病だけではなく、七大疾病をしっかりチェックして疾患リスクに備えてみてはいかがでしょうか。</p>
        <div className="row">
          <div className="col">
            <div className="summary_table">
              <div className="inddata">
                <table>
                  <tbody>
                  <tr>
                    <th scope="col">検査項目</th>
                    <th colSpan="2" scope="col">検査結果</th>
                  </tr>
                  <tr>
                    <td className="name">がん</td>
                    <td colSpan="2" >
                      <Link to={{
                        pathname: "/cancer",
                        state: { referer: "/sevens" }
                      }} ><div className="show_detail cancer_rink" onClick={this.handleClickSwitchPage.bind(this, "Cancer")}>がんのリスク評価を見る</div></Link>
                    </td>
                  </tr>
                  {this.state.results.map(data =>
                    <tr key={data.id}>
                      <td className="name">{data.unit.name}</td>
                      <td className={`riskrevel ${getColorStyle(data.level_type)}`}>{data.markup_level_name}</td>
                      <td className="detail">
                        <Link to={{
                          pathname: "/detail",
                          state: { referer: "/sevens" }
                        }} ><div className="show_detail" onClick={this.handleClickOpen.bind(this, data.unit.id)}>詳細を見る</div></Link>
                      </td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="about_canser">
              <h3>七大生活習慣病とは？</h3>
              <p className="text_description">
                日本人がかかりやすい７つの生活習慣病のことであり、一般的に、がん(悪性新生物）、心疾患、脳血管疾患、糖尿病、高血圧性疾患、肝硬変、慢性腎疾患のことを指します。
                これらの中でも「がん（悪性新生物）・心疾患・脳血管疾患」は三大疾病と呼ばれ、日本人の死因の上位を占めています。</p>
              <div>
                <img src="image/seven_major_disease.png" alt=""  />
              </div>
              <p className="text_description">
                生活習慣病は、乱れた食生活や運動不足、ストレスの蓄積、喫煙習慣、過度の飲酒など、不適切な生活習慣の継続によって発症する疾患の総称です。ただし、その発症には不適切な生活習慣の継続だけではなく、遺伝的な要因も関与していると考えられています。
                つまり、生活習慣病の予防にはご自身の体質にあった生活習慣の構築が重要です。遺伝子検査結果を是非ご活用ください。
                <br/>
                ちなみに、保険会社によって七大生活習慣病や三大疾病の定義が異なり、保険が保証する生活習慣病の範囲が異なる場合があります。例えば、三大疾病のうち、心疾患全体を対象にする保険もあれば、心筋梗塞のみを対象とする保険もあるようです。ご自身の遺伝子検査結果と保険の契約内容を見比べてみると良いかもしれません。
              </p>
            </div>

          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sevens.js